import {
  SET_NOTES,
  ADD_NOTE,
  UPDATE_NOTE,
  REMOVE_NOTE,
  SET_LOADING,
  SET_ERROR,
  SET_NOTE_WINDOW_SIZE,
  UPDATE_NOTE_WINDOW_SIZE_REQUEST,
  UPDATE_NOTE_WINDOW_SIZE_SUCCESS,
  UPDATE_NOTE_WINDOW_SIZE_FAILURE,
} from "./mutation-types";
import { RESET } from "../../mutation-types";

const getDefaultState = () => ({
  notes: [],
  loading: false,
  error: null,
  noteWindowWidth: null,
  noteWindowHeight: null,
});

const mutations = {
  [SET_NOTES]: (state, payload) => {
    state.notes = payload || [];
  },

  [ADD_NOTE]: (state, payload) => {
    state.notes.push(payload);
  },

  [UPDATE_NOTE]: (state, payload) => {
    const index = state.notes.findIndex(
      (note) => note.proposalNumber === payload.proposalNumber,
    );
    if (index !== -1) {
      state.notes.splice(index, 1, { ...state.notes[index], ...payload });
    }
  },

  [REMOVE_NOTE]: (state, proposalNumber) => {
    state.notes = state.notes.filter(
      (note) => note.proposalNumber !== proposalNumber,
    );
  },

  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },

  [SET_ERROR]: (state, payload) => {
    state.error = payload;
  },

  [SET_NOTE_WINDOW_SIZE]: (state, { width, height }) => {
    state.noteWindowWidth = width;
    state.noteWindowHeight = height;
  },

  [UPDATE_NOTE_WINDOW_SIZE_REQUEST]: (state) => {
    state.error = null;
  },

  [UPDATE_NOTE_WINDOW_SIZE_SUCCESS]: (state, { width, height }) => {
    state.noteWindowWidth = width;
    state.noteWindowHeight = height;
  },

  [UPDATE_NOTE_WINDOW_SIZE_FAILURE]: (state, error) => {
    state.error = error || "UPDATE_NOTE_WINDOW_SIZE_FAILED";
  },

  [RESET]: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export default mutations;
